import React from 'react';
import { IImageRepositoryItem, IImageRepositoryItemGroup } from './types';
import ImageRepositoryListItemGroup from './ImageRepositoryListItemGroup';

interface ImageRepositoryListProps {
  groups: IImageRepositoryItemGroup[];
  selectedItems: IImageRepositoryItem[];
  onItemSelect: (selected: boolean, item: IImageRepositoryItem) => void;
}

const ImageRepositoryList = ({
  groups,
  selectedItems,
  onItemSelect,
}: ImageRepositoryListProps) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      {groups.map((group, idx) => (
        <ImageRepositoryListItemGroup
          group={group}
          selectedItems={selectedItems.filter(
            (x) => x.articleNumber == group.articleNumber
          )}
          onItemSelect={onItemSelect}
          key={`${group.articleNumber}-${idx}-group`}
        />
      ))}
    </div>
  );
};

export default ImageRepositoryList;
